import { call, put, select } from "redux-saga/effects";
import { callAPI, METHODS } from "./apiSaga";
import {
  getConvertersDone,
  getConverterConfigDone,
  getConverters,
  getConverterConfig,
  addNConverters,
  addMdl_V7Converter,
  setCreatedDefaultConverters,
} from "../actions/actions";
//import {REACT_APP_FETCH_CONFIG} from "../../Properties/config.js";

const REACT_APP_FETCH_CONFIG =
  window.process !== undefined ? window.process.env.REACT_APP_FETCH_CONFIG : process.env.REACT_APP_FETCH_CONFIG;

const DO_NOT_CREATE_DEFAULT_CONVERTERS = 0;
const CREATE_ALL_DEFAULT_CONVERTERS = 1;
const CREATE_DEFAULT_MDL_V7_CONVERTER = 2;
const AUTOMATIC_CREATED_FILE_NOT_EXISTS = 3;

function isJson(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

function ConvertFromStoredNotchToPresentationNotch(str) {
  let ConverterConfigStringificado = str;
  // Convertimos de mombres almacenados (los antiguos) a los presentados
  ConverterConfigStringificado = ConverterConfigStringificado.replace(/GT_NOTCH_AUTO_ORIENTE/g, "GT_STANDARD_NOTCH");
  ConverterConfigStringificado = ConverterConfigStringificado.replace(/GT_NOTCH_ORIENTE/g, "GT_ANGLED_NOTCH");
  ConverterConfigStringificado = ConverterConfigStringificado.replace(
    /GT_DIRECTION_NOTCH_AUTO_ORIENTE/g,
    "EXTERNAL_STANDARD_NOTCH"
  );
  ConverterConfigStringificado = ConverterConfigStringificado.replace(
    /GT_DIRECTION_NOTCH_ORIENTE/g,
    "EXTERNAL_ANGLED_NOTCH"
  );
  return ConverterConfigStringificado;
}

function ConvertFromPresentationNotchToStoredNotch(str) {
  let ConverterConfigStringificado = str;
  // Convertimos de mombres presentados a los almacenados (los antiguos)
  ConverterConfigStringificado = ConverterConfigStringificado.replace(/GT_STANDARD_NOTCH/g, "GT_NOTCH_AUTO_ORIENTE");
  ConverterConfigStringificado = ConverterConfigStringificado.replace(/GT_ANGLED_NOTCH/g, "GT_NOTCH_ORIENTE");
  ConverterConfigStringificado = ConverterConfigStringificado.replace(
    /EXTERNAL_STANDARD_NOTCH/g,
    "GT_DIRECTION_NOTCH_AUTO_ORIENTE"
  );
  ConverterConfigStringificado = ConverterConfigStringificado.replace(
    /EXTERNAL_ANGLED_NOTCH/g,
    "GT_DIRECTION_NOTCH_ORIENTE"
  );
  return ConverterConfigStringificado;
}
export function* GetConverters(action) {
  let convertertype = "converters";
  let converterId = "converters";
  const url = REACT_APP_FETCH_CONFIG + "-conf/" + convertertype + "/" + converterId;
  const { success, result } = yield call(callAPI, { url });

  if (success) {
    let converters = result.toString();
    if (converters === "" || isJson(converters) === false) converters = '{"Converter":[]}';
    const { Converter } = JSON.parse(converters);

    /*
    if (Converter.length === 0) {
      // si han sido crerados conversiores por defecto, no llamamos a esta función.
      // para ello, llamamos a la función GetAutomaticCreatedConverters (devuelve true o false)

      bGetAutomaticCreatedConverters = yield call(GetAutomaticCreatedConverters);

      if (bGetAutomaticCreatedConverters === false) yield call(CreateDefaultConverters);
    }*/

    //First we look at the automatic creation according to the automatic creation file
    let nGetAutomaticCreatedConverters = yield call(GetAutomaticCreatedConverters);

    //If that automatic creation file does not exist, we evaluate whether to create the mdl_v7
    if (nGetAutomaticCreatedConverters === AUTOMATIC_CREATED_FILE_NOT_EXISTS) {
      /*
      The converters file does not exist
       If there are converters, but no mdl_v7. nRetAutomaticCreatedConverters = CREATE_DEFAULT_MDL_V7_CONVERTER;
       if there are no converters nRetAutomaticCreatedConverters = CREATE_ALL_DEFAULT_CONVERTERS;
       otherwise nRetAutomaticCreatedConverters = DO_NOT_CREATE_DEFAULT_CONVERTERS;*/
      let bExistenConversores = false;
      let bExistenMdl_V7Conversores = false;
      if (Converter.length > 0) {
        bExistenConversores = true;
        let i = 0;
        while (i < Converter.length) {
          if (Converter[i].typeDestination === "mdl_V7") bExistenMdl_V7Conversores = true;
          i++;
        }
      }

      if (bExistenConversores && !bExistenMdl_V7Conversores)
        nGetAutomaticCreatedConverters = CREATE_DEFAULT_MDL_V7_CONVERTER;

      if (!bExistenConversores) nGetAutomaticCreatedConverters = CREATE_ALL_DEFAULT_CONVERTERS;
    }

    if (Converter.length === 0) {
      if (nGetAutomaticCreatedConverters === CREATE_ALL_DEFAULT_CONVERTERS) yield call(CreateDefaultConverters);
    } else if (nGetAutomaticCreatedConverters === CREATE_DEFAULT_MDL_V7_CONVERTER) yield call(CreateMDL_V7Converter);

    yield put(getConvertersDone(Converter));
  }
}
export function* CreateDefaultConverters(action) {
  const createdDefaultConverters = yield select((state) => state.createdDefaultConverters);
  if (createdDefaultConverters === false) {
    let convertersACrear = [
      {
        id: "AAMA_ASTM",
        type: "aama_astm",
        typeDestination: "mdl",
        typeInOut: "In",
      },
      {
        id: "Accumark standard",
        type: "accumark",
        typeDestination: "mdl",
        typeInOut: "In",
      },
      {
        id: "MDL V7",
        type: "mdl",
        typeDestination: "mdl_V7",
        typeInOut: "Out",
      },
    ];
    yield put(setCreatedDefaultConverters(true));
    yield put(addNConverters({ Converters: convertersACrear }));
  }
}

export function* CreateMDL_V7Converter(action) {
  const createdDefaultConverters = yield select((state) => state.createdDefaultConverters);
  if (createdDefaultConverters === false) {
    let convertersACrear = [
      {
        id: "MDL V7",
        type: "mdl",
        typeDestination: "mdl_V7",
        typeInOut: "Out",
      },
    ];
    yield put(setCreatedDefaultConverters(true));
    //yield put(addConverter({ Converters: convertersACrear }));

    yield put(addMdl_V7Converter({ id: "MDL V7", type: "mdl", typeDestination: "mdl_V7", typeInOut: "Out" }));
  }
}

export function* AddConverter(action) {
  // we create new converter on state, that is copied (pointed) to store
  const updatedConverters = yield select((state) => state.converters);
  let newConverter = {
    id: action.payload.id,
    type: action.payload.type,
    typeDestination: action.payload.typeDestination,
    typeInOut: action.payload.typeInOut,
  };
  updatedConverters.push(newConverter);

  const myConverters = { Converter: updatedConverters };
  const url = REACT_APP_FETCH_CONFIG + "-conf/";

  var body = new FormData();
  body.append("json_string", JSON.stringify(myConverters));
  body.append("converter_type", "converters");
  body.append("converter_id", "converters");

  var method = METHODS.POST;

  const { success } = yield call(callAPI, { url, method, body });

  if (success) {
    yield put(getConverters({}));
  }
}

export function* AddNConverters(action) {
  /*Realizar otra funcion AddNConverters
  parametros: en action, vendría un array de converters,
  acederiamos recorriendolo (con action.payload[2].id....)
  Generamos updatedConverters
  */

  const converters = yield select((state) => state.converters);
  let nNumConversores = converters.length;

  if (nNumConversores === 0) {
    const updatedConverters = [
      {
        id: action.payload.Converters[0].id,
        type: action.payload.Converters[0].type,
        typeDestination: action.payload.Converters[0].typeDestination,
        typeInOut: action.payload.Converters[0].typeInOut,
      },

      {
        id: action.payload.Converters[1].id,
        type: action.payload.Converters[1].type,
        typeDestination: action.payload.Converters[1].typeDestination,
        typeInOut: action.payload.Converters[1].typeInOut,
      },
      {
        id: action.payload.Converters[2].id,
        type: action.payload.Converters[2].type,
        typeDestination: action.payload.Converters[2].typeDestination,
        typeInOut: action.payload.Converters[2].typeInOut,
      },
    ];

    // Creamos los conversores
    const myConverters = { Converter: updatedConverters };
    const url = REACT_APP_FETCH_CONFIG + "-conf/";

    var body = new FormData();
    body.append("json_string", JSON.stringify(myConverters));
    body.append("converter_type", "converters");
    body.append("converter_id", "converters");

    var method = METHODS.POST;
    console.log("AddNConverters ----- Antes de crear los siguientes conversores-------");
    console.log(myConverters);
    const { success } = yield call(callAPI, { url, method, body });

    if (success) {
      yield put(getConverters({}));
      // Anotamos que se han creado los conversores automáticos
      yield call(SetAutomaticCreatedConverters);
    }
  }
}

export function* AddMdl_V7Converter(action) {
  //No podemos leerlos de redux, puesto que todavía noe stán allí: Hay que leerlo directamente del API

  let convertertype = "converters";
  let converterId = "converters";
  const url = REACT_APP_FETCH_CONFIG + "-conf/" + convertertype + "/" + converterId;
  const { success, result } = yield call(callAPI, { url });

  if (success) {
    let converters = result.toString();
    if (converters === "" || isJson(converters) === false) converters = '{"Converter":[]}';
    const { Converter } = JSON.parse(converters);
    console.log("AddMdl_V7Converter");
    console.log(Converter.length);

    //const converters = yield select((state) => state.converters);
    let nNumConversores = Converter.length;

    if (nNumConversores >= 0) {
      const updatedConverters = [
        ...Converter,
        {
          id: action.payload.id,
          type: action.payload.type,
          typeDestination: action.payload.typeDestination,
          typeInOut: action.payload.typeInOut,
        },
      ];

      // Creamos los conversores
      const myConverters = { Converter: updatedConverters };
      const url = REACT_APP_FETCH_CONFIG + "-conf/";

      var body = new FormData();
      body.append("json_string", JSON.stringify(myConverters));
      body.append("converter_type", "converters");
      body.append("converter_id", "converters");

      var method = METHODS.POST;
      console.log("AddNConverters ----- Antes de crear los siguientes conversores-------");
      console.log(myConverters);
      const { success } = yield call(callAPI, { url, method, body });

      if (success) {
        yield put(getConverters({}));
        // Anotamos que se han creado los conversores automáticos
        yield call(SetAutomaticCreatedConverters);
      }
    }
  }
}
export function* SetAutomaticCreatedConverters(action) {
  //
  const url = REACT_APP_FETCH_CONFIG + "-conf/";

  const createdAutoConverters = {
    accumark: true,
    aama_astm: true,
    mdl_v7: true,
  };
  var body = new FormData();
  body.append("json_string", JSON.stringify(createdAutoConverters));
  body.append("converter_type", "converters");
  body.append("converter_id", "automaticcreatedconverters");

  var method = METHODS.POST;
  console.log("SetAutomaticCreatedConverters ----- Antes de anotar conversores creados automáticamente-------");
  console.log(createdAutoConverters);
  const { success } = yield call(callAPI, { url, method, body });

  if (success) {
    yield put(getConverters({}));
    // Anotamos que se han creado los conversores automáticos
  }
}
export function* GetAutomaticCreatedConverters() {
  let convertertype = "converters";
  let converterId = "automaticcreatedconverters";
  let bExistAutomaticDefaultConverters = false;
  let bExistAutomaticAccuMarkAamaAstmDefaultConverters = false;
  let bExistAutomaticMdl_v7DefaultConverter = false;
  let nRetAutomaticCreatedConverters = DO_NOT_CREATE_DEFAULT_CONVERTERS;
  /*
  const DO_NOT_CREATE_DEFAULT_CONVERTERS = 0;
  const CREATE_ALL_DEFAULT_CONVERTERS = 1;
  const CREATE_DEFAULT_MDL_V7_CONVERTER = 2;
  */

  const url = REACT_APP_FETCH_CONFIG + "-conf/" + convertertype + "/" + converterId;
  let { success, result } = yield call(callAPI, { url });

  if (success) {
    let AutomaticDefaultConverters = result.toString();
    if (AutomaticDefaultConverters === "" || isJson(AutomaticDefaultConverters) === false) {
      /* si isJson(AutomaticDefaultConverters) === false, significa que no hay fichero de configuración de creados automáticamente

      */

      nRetAutomaticCreatedConverters = AUTOMATIC_CREATED_FILE_NOT_EXISTS;
      bExistAutomaticDefaultConverters = false;
    } else {
      const AutomaticConverters = JSON.parse(AutomaticDefaultConverters);
      // 1st; we check if all converters type has been created atomatically
      if (
        AutomaticConverters.accumark === true ||
        AutomaticConverters.aama_astm === true ||
        AutomaticConverters.mdl_v7 === true
      ) {
        bExistAutomaticDefaultConverters = true;
      } else {
        bExistAutomaticDefaultConverters = false;
      }

      if (AutomaticConverters.accumark === true || AutomaticConverters.aama_astm === true)
        bExistAutomaticAccuMarkAamaAstmDefaultConverters = true;
      if (AutomaticConverters.mdl_v7 === true) bExistAutomaticMdl_v7DefaultConverter = true;

      if (!(bExistAutomaticAccuMarkAamaAstmDefaultConverters || bExistAutomaticMdl_v7DefaultConverter))
        nRetAutomaticCreatedConverters = CREATE_ALL_DEFAULT_CONVERTERS;
      else if (bExistAutomaticAccuMarkAamaAstmDefaultConverters && !bExistAutomaticMdl_v7DefaultConverter)
        nRetAutomaticCreatedConverters = CREATE_DEFAULT_MDL_V7_CONVERTER;
    }
  }
  //return bExistAutomaticDefaultConverters;
  return nRetAutomaticCreatedConverters;
}

export function* CopyConverter(action) {
  let id = action.payload.id;
  const converters = yield select((state) => state.converters);
  let exist = true;
  let ndx = 1;
  while (exist) {
    id = id + ndx;
    if (converters.findIndex((converter) => converter.id === id) < 0) exist = false;
    ndx++;
    if (ndx > 100) break;
  }

  const updatedAction = {
    ...action,
    payload: {
      ...action.payload,
      id,
    },
  };
  yield* AddConverter(updatedAction);
  yield* copyConverterConfig(
    action.payload.id,
    action.payload.type,
    action.payload.typeDestination,
    action.payload.typeInOut,
    id
  );
}

export function* RemoveConverter(action) {
  const converters = yield select((state) => state.converters);
  const index = converters.findIndex((converter) => converter.id === action.payload.id);
  if (index >= 0) {
    converters.splice(index, 1);
  }

  const myConverters = { Converter: converters };
  const url = REACT_APP_FETCH_CONFIG + "-conf/";

  var body = new FormData();
  body.append("json_string", JSON.stringify(myConverters));
  body.append("converter_type", "converters");
  body.append("converter_id", "converters");
  ///////////////////////////////////////////////////////
  /*body.append("converter_typeDestination", "converters");
  body.append("converter_typeInOut", "converters");*/
  ///////////////////////////////////////////////////////
  var method = METHODS.POST;
  const { success } = yield call(callAPI, { url, method, body });

  if (success) {
    yield put(getConverters({}));
  }
}

export function* UpdateConverterType(action) {
  const converters = yield select((state) => state.converters);
  const index = converters.findIndex((converter) => converter.id === action.payload.id);
  if (index >= 0) {
    //converters[index].type = action.payload.type;
    //converters[index].typeDestination = action.payload.typeDestination;
    converters[index].typeInOut = action.payload.typeInOut;
    if (converters[index].typeInOut === "In") {
      converters[index].type = action.payload.type;
      converters[index].typeDestination = "mdl";
    } else if (converters[index].typeInOut === "Out") {
      converters[index].type = "mdl";
      converters[index].typeDestination = action.payload.type;
    }
  }

  const myConverters = { Converter: converters };
  const url = REACT_APP_FETCH_CONFIG + "-conf/";

  var body = new FormData();
  body.append("json_string", JSON.stringify(myConverters));
  body.append("converter_type", "converters");
  body.append("converter_id", "converters");
  ///////////////////////////////////////////////////////
  body.append("converter_typeDestination", "converters");
  body.append("converter_typeInOut", "converters");
  ///////////////////////////////////////////////////////

  var method = METHODS.POST;
  const { success } = yield call(callAPI, { url, method, body });

  if (success) {
    yield put(getConverters({}));
  }
}

export function* UpdateConverterOrder(action) {
  //const converters = yield select(state => state.converters);
  const myConverters = { Converter: action.payload };
  const url = REACT_APP_FETCH_CONFIG + "-conf/";

  var body = new FormData();
  body.append("json_string", JSON.stringify(myConverters));
  body.append("converter_type", "converters");
  body.append("converter_id", "converters");

  var method = METHODS.POST;
  const { success } = yield call(callAPI, { url, method, body });

  if (success) {
    yield put(getConverters({}));
  }
}
export function* UpdateConverterMultipleMdl(action) {
  // 1st. find converter, and if exists (== action.payload.id),
  // add status  (or update status) with that value
  //(converters[index].multiplemdl = action.payload.multiplemdl;)
  const converters = yield select((state) => state.converters);
  const index = converters.findIndex((converter) => converter.id === action.payload.id);
  if (index >= 0) {
    converters[index].multiplemdl = action.payload.multiplemdl;
    if (converters[index].type === "mdl") {
      /*converters[index].typeInOut = "Out";
      converters[index].typeDestination = "accumark";*/
    } else {
      converters[index].typeInOut = "In";
      converters[index].typeDestination = "mdl";
    }
  }
  //2nd upload to cloud
  const myConverters = { Converter: converters };
  //myConverters contans all parameters(attributes) of one converter
  const url = REACT_APP_FETCH_CONFIG + "-conf/";

  var body = new FormData();
  body.append("json_string", JSON.stringify(myConverters));
  body.append("converter_type", "converters");
  body.append("converter_id", "converters");
  ///////////////////////////////////////////////////////
  body.append("converter_typeDestination", "converters");
  body.append("converter_typeInOut", "converters");
  ///////////////////////////////////////////////////////

  var method = METHODS.POST;
  const { success } = yield call(callAPI, { url, method, body });

  if (success) {
    yield put(getConverters({}));
  }
}
export function* UpdateConverterId(action) {
  const url = REACT_APP_FETCH_CONFIG + "-conf/converters/converters";
  const { success, result } = yield call(callAPI, { url });
  let exist = false;

  if (success) {
    //Verify new name not exist in cloud
    let converters = result.toString();
    let index = -1;
    if (converters === "" || isJson(converters) === false) converters = '{"Converter":[]}';
    const { Converter } = JSON.parse(converters);
    if (Converter.length > 0) {
      let i = 0;
      while (i < Converter.length) {
        if (Converter[i].id === action.payload.newid) exist = true;
        i++;
      }

      i = 0;
      let found = false;
      while (i < Converter.length && !found) {
        if (Converter[i].id === action.payload.id) {
          found = true;
          index = i;
        }
        i++;
      }
    }

    if (exist === true) {
      alert("UpdateConverterId already exists: " + action.payload.newid);
      return;
    } else {
      const converters = yield select((state) => state.converters);
      //const index = converters.findIndex((converter) => converter.id === action.payload.id);
      let type = "";
      let typeDestination = "";
      let typeInOut = "";

      if (index >= 0) {
        if (converters[index].type === "mdl") {
          converters[index].typeInOut = "Out";
          /*converters[index].typeDestination = "accumark";*/
        } else {
          converters[index].typeInOut = "In";
          converters[index].typeDestination = "mdl";
        }

        converters[index].id = action.payload.newid;
        type = converters[index].type;
        typeDestination = converters[index].typeDestination;
        typeInOut = converters[index].typeInOut;
      }
      yield* copyConverterConfig(action.payload.id, type, typeDestination, typeInOut, action.payload.newid);
      const myConverters = { Converter: converters };
      const url = REACT_APP_FETCH_CONFIG + "-conf/";

      var body = new FormData();
      body.append("json_string", JSON.stringify(myConverters));
      body.append("converter_type", "converters");
      body.append("converter_id", "converters");
      body.append("converter_typeDestination", "converters");
      body.append("converter_typeInOut", "converters");
      var method = METHODS.POST;
      let { success } = yield call(callAPI, { url, method, body });

      if (success) {
        yield put(getConverters({}));
      }
    }
  }
}
export function* GetConverterConfig(action) {
  const url = REACT_APP_FETCH_CONFIG + "-conf/" + action.payload.type + "/" + action.payload.id;

  const { success, result } = yield call(callAPI, { url });

  if (success) {
    let ConverterConfigStringificado = result;

    // Convertimos de mombres almacenados (los antiguos) a los presentados
    //ConverterConfigStringificado = ConvertFromStoredNotchToPresentationNotch(ConverterConfigStringificado);

    //const ConverterConfig = isJson(result) ? JSON.parse(result) : {};
    const ConverterConfig = isJson(ConverterConfigStringificado) ? JSON.parse(ConverterConfigStringificado) : {};
    yield put(getConverterConfigDone(ConverterConfig));
  } else {
  }
}
export function* SetConfigParam(action) {
  const converterconfig = yield select((state) => state.converterconfig);
  converterconfig[action.payload.paramid] = action.payload.paramvalue;
  //

  const url = REACT_APP_FETCH_CONFIG + "-conf/";
  var body = new FormData();
  let ConverterConfigStringificado = JSON.stringify(converterconfig);
  // Convertimos de mombres presentados a los almacenados (los antiguos)
  //ConverterConfigStringificado = ConvertFromPresentationNotchToStoredNotch(ConverterConfigStringificado);

  // body.append("json_string", JSON.stringify(converterconfig));
  body.append("json_string", ConverterConfigStringificado);
  body.append("converter_type", action.payload.convertertype);
  body.append("converter_id", action.payload.converterid);
  ///////////////////////////////////////////////////////
  /*
  body.append(
    "converter_typeDestination",
    action.payload.convertertypeDestination
  );
  body.append("converter_typeInOut", action.payload.convertertypeInOut);*/
  ///////////////////////////////////////////////////////

  var method = METHODS.POST;
  const { success } = yield call(callAPI, { url, method, body });

  if (success) {
    yield put(
      getConverterConfig({
        id: action.payload.converterid,
        type: action.payload.convertertype,
        typeDestination: action.payload.convertertypeDestinationt,
        typeInOut: action.payload.convertertypeInOut,
      })
    );
  }
}

export function* RemoveConfigParam(action) {
  const converterconfig = yield select((state) => state.converterconfig);

  delete converterconfig[action.payload.paramid];
  const url = REACT_APP_FETCH_CONFIG + "-conf/";

  var body = new FormData();
  let ConverterConfigStringificado = JSON.stringify(converterconfig);
  // Convertimos de mombres presentados a los almacenados (los antiguos)
  //ConverterConfigStringificado = ConvertFromPresentationNotchToStoredNotch(ConverterConfigStringificado);
  //body.append("json_string", JSON.stringify(converterconfig));
  body.append("json_string", ConverterConfigStringificado);
  body.append("converter_type", action.payload.convertertype);
  body.append("converter_id", action.payload.converterid);
  ///////////////////////////////////////////////////////
  body.append("converter_typeDestination", action.payload.convertertypeDestination);
  body.append("converter_typeInOut", action.payload.convertertypeInOut);
  ///////////////////////////////////////////////////////

  var method = METHODS.POST;
  const { success } = yield call(callAPI, { url, method, body });

  if (success) {
    yield put(
      getConverterConfig({
        id: action.payload.converterid,
        type: action.payload.convertertype,
        typeDestination: action.payload.convertertypeDestinationt,
        typeInOut: action.payload.convertertypeInOut,
      })
    );
  }
}

export function* copyConverterConfig(id, type, typeDestination, typeInOut, newid) {
  //yield* GetConverterConfig({ payload: { id: id, type: type } });
  yield* GetConverterConfig({
    payload: {
      id: id,
      type: type,
      typeDestination: typeDestination,
      typeInOut: typeInOut,
    },
  });
  const converterconfig = yield select((state) => state.converterconfig);

  const url = REACT_APP_FETCH_CONFIG + "-conf/";

  var body = new FormData();
  let ConverterConfigStringificado = JSON.stringify(converterconfig);

  // Convertimos de mombres presentados a los almacenados (los antiguos)
  //ConverterConfigStringificado = ConvertFromPresentationNotchToStoredNotch(ConverterConfigStringificado);

  //body.append("json_string", JSON.stringify(converterconfig));
  body.append("json_string", ConverterConfigStringificado);
  body.append("converter_type", type);
  body.append("converter_id", newid);
  ///////////////////////////////////////////////////////
  body.append("converter_typeDestination", typeDestination);
  body.append("converter_typeInOut", typeInOut);
  ///////////////////////////////////////////////////////

  var method = METHODS.POST;
  const { success } = yield call(callAPI, { url, method, body });
  if (success) {
  }
}
export function* SetConfigConverter(action) {
  const converterconfig = action.payload.configuration;
  const url = REACT_APP_FETCH_CONFIG + "-conf/";
  var body = new FormData();
  let ConverterConfigStringificado = JSON.stringify(converterconfig);
  body.append("json_string", ConverterConfigStringificado);
  body.append("converter_type", action.payload.convertertype);
  body.append("converter_id", action.payload.converterid);
  var method = METHODS.POST;
  const { success } = yield call(callAPI, { url, method, body });
  if (success) {
    yield put(
      getConverterConfig({
        id: action.payload.converterid,
        type: action.payload.convertertype,
        typeDestination: action.payload.convertertypeDestinationt,
        typeInOut: action.payload.convertertypeInOut,
      })
    );
  }
}
